/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react'

import LanguageAccordion from '@/features/menu-management/SidebarAccordion/components/LanguageAccordion/LanguageAccordion'
import { useTranslation } from 'react-i18next'
import styles from './SidebarAccordion.module.scss'

import MenuTypesAccordion from './components/MenuTypesAccordion/MenuTypesAccordion'
import DishSizesAccordion from './components/DishSizesAccordion/DishSizesAccordion'
import DishCategoriesAccordion from './components/DishCategoriesAccordion/DishCategoriesAccordion'
import ChartsSettingsAccordion from './components/ChartsSettingsAccordion/ChartsSettingsAccordion'

function SidebarAccordion() {
  const [openAccordion, setOpenAccordion] = useState(-1)
  const { t } = useTranslation()

  const handleAccordionClick = (index: number) => {
    if (openAccordion === index) {
      setOpenAccordion(-1)
      return
    }
    setOpenAccordion(index)
  }

  return (
    <div className={styles.accordionWrapper}>
      <p className={`title-bold-medium ${styles.sidebarAccordionTitle}`}>
        {t('SIDEBAR_ACCORDION.TITLE')}
      </p>
      <div className={`${styles.accordionTilesGroup}`}>
        <ChartsSettingsAccordion
          accordionIndex={0}
          openAccordion={openAccordion}
          handleAccordionClick={handleAccordionClick}
        />
        <LanguageAccordion
          accordionIndex={1}
          openAccordion={openAccordion}
          handleAccordionClick={handleAccordionClick}
        />
        <DishCategoriesAccordion
          accordionIndex={2}
          openAccordion={openAccordion}
          handleAccordionClick={handleAccordionClick}
        />
        <MenuTypesAccordion
          accordionIndex={3}
          openAccordion={openAccordion}
          handleAccordionClick={handleAccordionClick}
        />
        <DishSizesAccordion
          accordionIndex={4}
          openAccordion={openAccordion}
          handleAccordionClick={handleAccordionClick}
        />
      </div>
    </div>
  )
}

export default SidebarAccordion
